// extracted by mini-css-extract-plugin
module.exports = {"width":"services_width__wupVV","hero-text":"services_hero-text__3KnkG","wrapper":"services_wrapper__AU37S","split":"services_split__yyv8x"};